var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 10,
    viewBox: "0 0 3 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84034 0.695578L2.63631 6.01075L1.24411 6.01075L1.01608 0.695578L2.84034 0.695578ZM1.94021 7.13857C2.22825 7.13857 2.47229 7.23856 2.67232 7.43853C2.87235 7.63849 2.97236 7.87846 2.97236 8.15841C2.97236 8.43837 2.87235 8.68233 2.67232 8.8903C2.47229 9.09027 2.22825 9.19025 1.94021 9.19025C1.66017 9.19025 1.42013 9.09027 1.22011 8.8903C1.02008 8.68233 0.920061 8.43837 0.920061 8.15841C0.920061 7.87846 1.02008 7.63849 1.22011 7.43853C1.42013 7.23856 1.66017 7.13857 1.94021 7.13857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/important-icon.2e39eb5a98affe166833074d1cd04b70.svg";
export { ForwardRef as ReactComponent };